function SiteHeader(isLoggedIn) {

    var self = this;

    // Observables
    self.isBottomBorderVisible = ko.observable(true);
    self.IsUserLoggedIn = ko.observable(isLoggedIn);
    
    // Sub Models
    self.breadcrumbs = new Breadcrumbs("", null, false);

    // Computeds
    self.isPublicBusinessPage = ko.computed(function() {
        return window.location.href.indexOf("/business") !== -1;
    });

    self.homeLogoHref = ko.computed(function() {
        if (self.IsUserLoggedIn()) {
            return "/computers#main";
        } else {
            return self.isPublicBusinessPage() ? "/business" : "/";
        }
    });

    self.loginHref = ko.computed(function() {
        return self.isPublicBusinessPage() ? "/business/login" : "/login";
    });

    self.signupHref = ko.computed(function() {
        return self.isPublicBusinessPage() ? "/signup/business" : "/signup";
    });
}